import CrudBaseService from "@/services/CrudBaseService";

export default class QuoteService extends CrudBaseService {

  constructor() {
    super('odoo/quote');
  }

  getMaxAttempts(){
    return 18;
  }

  async findAllPlansByFilter(params) {
    return await this.http.get(`${this._serviceName}/findAllPlansByFilter?${params}`);
  }


  async requestKit(data) {
    return await this.http.post(`${this._serviceName}/request-kit`, data);
  }

  async calculateAndDownloadQuote(data) {
    return await this.http.post(`${this._serviceName}/calculate`, data, {timeout: 0});
  }

  async calculateAndDownloadQuotePolling(data) {
    try {
      // Step 1: Initiate the Asynchronous Task
      const response = await this.http.post(`${this._serviceName}/calculate-async`, data, {timeout: 0});
      const jobId = response.data.jobId; // Assuming the response contains the job ID
  
      // Step 2: Periodically Poll for Status
      return new Promise((resolve, reject) => {
        let attempts = 0;  // Initialize the counter

        const interval = setInterval(async () => {
        
          try {
            attempts++; 
            const statusResponse = await this.http.get(`${this._serviceName}/calculate-async/check?jobId=${jobId}`);
            const { jobStatus, result, message } = statusResponse.data;
  
            if (jobStatus === 'DONE' || jobStatus === 'ERROR') {
              clearInterval(interval);
              if (jobStatus === 'DONE') {
                resolve(result);
              } else {
                reject(new Error(message || 'An error occurred'));
              }
            }
            // If jobStatus is not 'DONE' or 'ERROR', the interval continues
            // Stop polling after 10 attempts
            if (attempts >= this.getMaxAttempts()) {
              clearInterval(interval);
              reject(new Error('Tempo de espera excedido.'));
            }

          } catch (error) {
            clearInterval(interval);
            reject(error);
          }
        }, 10000); // Poll every 3 seconds
      });
    } catch (error) {
      return Promise.reject(error);
    }
  }
  

  async findAllByFilter(params) {
    return await this.http.get(`${this._serviceName}/findAllByFilter?${params}`);
  }
  
  async sendInstitutional(params) {
    return await this.http.post(`${this._serviceName}/send-institutional?${params}`);
  }
  
  async detail(id) {
    return await this.http.get(`${this._serviceName}/detail/${id}`);
  }

  async download(id, quoteFileType) {
    return await this.http.get(`${this._serviceName}/download/${id}/${quoteFileType}`);
  }

  async sendKit(params) {
    return await this.http.post(`${this._serviceName}/send-kit?${params}`);
  }
  async sendFinancialResume(params) {
    return await this.http.post(`${this._serviceName}/send-financial-resume?${params}`);
  }

  async save(quoteDto) {
    return await this.http.post(`${this._serviceName}/save`, quoteDto);
  }

  async savePolling(data) {
    try {
      // Step 1: Initiate the Asynchronous Task
      const response = await this.http.post(`${this._serviceName}/save-async`, data, {timeout: 0});
      const jobId = response.data.jobId; // Assuming the response contains the job ID
  
      // Step 2: Periodically Poll for Status
      return new Promise((resolve, reject) => {
        let attempts = 0;  // Initialize the counter

        const interval = setInterval(async () => {
          try {
            attempts++; 
            
            const statusResponse = await this.http.get(`${this._serviceName}/save-async/check?jobId=${jobId}`);
            const { jobStatus, result, message } = statusResponse.data;
  
            if (jobStatus === 'DONE' || jobStatus === 'ERROR') {
              clearInterval(interval);
              if (jobStatus === 'DONE') {
                resolve(result);
              } else {
                reject(new Error(message || 'An error occurred'));
              }
            }
            // If jobStatus is not 'DONE' or 'ERROR', the interval continues
            // Stop polling after 3 min
            if (attempts >= this.getMaxAttempts()) {
                clearInterval(interval);
                reject(new Error('Tempo de espera excedido.'));
            }

          } catch (error) {
            clearInterval(interval);
            reject(error);
          }
        }, 10000); // Poll every 3 seconds
      });
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
